import React, { useEffect, useState } from "react";
import { Card, CardBody, Heading } from "@pancakeswap-libs/uikit";
import styled from "styled-components";
import "./index.css";

import { getTotalBnbAndEthStaked } from "utils/VoteHarvest";

const StyledTwitterCard = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  background: linear-gradient(
    162.44deg,
    #000000 49.97%,
    rgba(0, 0, 0, 0) 98.44%
  );
  border: 1px solid #ffffff;
  box-sizing: border-box;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  .innerBox {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: 280px;
  }
`;

const Bar = styled.div`
  position: relative;
  width: 80px;
  height: 200px;
  background-color: #323232;
  border-radius: 10px;
  .colorBox1 {
    position: absolute;
    width: 100%;
    bottom: 0;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background: #65799d;
  }
  .colorBox2 {
    position: absolute;
    width: 100%;
    bottom: 0;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background: #fefbc2;
  }
`;

const ChainDominance = () => {
  const [staked, setStaked] = useState<any>({});

  useEffect(() => {
    const d = async () => {
      const EthBnbPercent = await getTotalBnbAndEthStaked();
      setStaked(EthBnbPercent);
    };
    d();
  }, []);

  return (
    <StyledTwitterCard>
      <CardBody>
        <Heading
          style={{
            textAlign: "center",
            fontSize: "24px",
            fontWeight: 600,
            marginBottom: "24px",
          }}
          size="xl"
        >
          DDAO Chain Dominance
        </Heading>
        <Container>
          <div className="innerBox">
            <p>
              {Number.isNaN(Number(staked?.ethPercent))
                ? 0
                : staked?.ethPercent}
              %
            </p>
            <Bar>
              <div
                style={{ height: `${staked?.ethPercent}%` }}
                className="colorBox1"
              />
            </Bar>
            <p>ETH</p>
          </div>
          <div className="innerBox">
            <p>
              {!Number.isNaN(Number(staked?.bnbPercent))
                ? staked?.bnbPercent
                : 0}
              %
            </p>
            <Bar>
              <div
                style={{ height: `${staked?.bnbPercent}%` }}
                className="colorBox2"
              />
            </Bar>
            <p>BSC</p>
          </div>
        </Container>
      </CardBody>
    </StyledTwitterCard>
  );
};

export default ChainDominance;
